module.exports = __webpack_public_path__ + "img/tfc1.ddede726.png";